import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/site";
import { PipitoneButton } from "@/components/decor";

const LINKS = [
  { id: "percorsi", label: "Il Percorso", testId: "nav-link-percorsi" },
  { id: "chi-sono", label: "Dr. med. Nicolò Pipitone", testId: "nav-link-chi-sono" },
  { id: "incontri", label: "I 6 Incontri", testId: "nav-link-incontri" },
  { id: "calendario", label: "Calendario", testId: "nav-link-calendario" },
  { id: "contatti", label: "Contatti", testId: "nav-link-contatti" },
];

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,border-color] duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-[#FAF8F5]/85 border-b border-[#E2D9CD]/70 shadow-[0_4px_24px_rgba(12,27,51,0.05)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8 lg:px-12">
        <button
          data-testid="nav-brand"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="group flex items-baseline gap-2 text-left"
        >
          <span className="font-display text-xl font-semibold tracking-tight text-[#0C1B33] sm:text-2xl">
            Arcipelago
          </span>
        </button>

        <button
          data-testid="nav-cta-iscriviti"
          onClick={() => scrollToId("iscrizione")}
          className="group relative ml-2 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-[#C93B2B] px-3.5 py-2 text-[11px] font-bold uppercase tracking-[0.06em] text-white shadow-[0_8px_24px_rgba(201,59,43,0.4)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#a52f22] hover:shadow-[0_12px_32px_rgba(201,59,43,0.5)] active:translate-y-0 sm:ml-5 sm:px-7 sm:py-3 sm:text-sm"
        >
          <span className="absolute -right-1 -top-1 flex h-3 w-3 sm:h-3.5 sm:w-3.5" aria-hidden>
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#C93B2B] opacity-60" />
            <span className="relative inline-flex h-full w-full rounded-full border-2 border-[#FAF8F5] bg-[#C93B2B]" />
          </span>
          Iscriviti ora
        </button>

        <nav className="hidden items-center gap-7 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => scrollToId(l.id)}
              className="group relative text-sm font-medium text-[#0C1B33]/80 transition-colors hover:text-[#0C1B33]"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#0D9488] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <PipitoneButton testId="pipitone-link-nav" compact />
        </div>
      </div>
    </motion.header>
  );
};

export default Nav;
